document.addEventListener('DOMContentLoaded', function () {
  function waitForJsonElement(selector, timeout = 5000) {
    return new Promise((resolve, reject) => {
      const interval = 100;
      const start = Date.now();

      const check = () => {
        const el = document.querySelector(selector);
        if (el) return resolve(el);
        if (Date.now() - start >= timeout) return reject(new Error('⛔ JSON <script> nenalezen'));
        setTimeout(check, interval);
      };
      check();
    });
  }

  waitForJsonElement('#menu-data', 8000)
    .then(menuDataEl => {
      let menuJson;
      try {
        menuJson = JSON.parse(menuDataEl.textContent);
      } catch (e) {
        console.error('❌ Chyba při parsování JSON:', e);
        return;
      }

      const menuItems = menuJson.menu;
      if (!Array.isArray(menuItems) || !menuItems.length) {
        console.warn('⚠️ Žádná položka menu ve `menuJson.menu`');
        return;
      }

      const replayMenu = document.createElement('div');
      replayMenu.className = 'replay-megamenu-root header__nav';

      const topUl = document.createElement('ul');
      topUl.className = 'replay-top-level';

      /*const imgMap = {
        'Muži|Džíny': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/01-600x243.jpg',
        'Muži|Oblečení': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/02-600x243.jpg',
        'Muži|Doplňky': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/03-600x243.jpg',
        'Muži|Obuv': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/04-600x243.jpg',
        'Muži|Projekty': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/05-600x243.jpg',
        'Muži|Kolekce': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/05-600x243.jpg',
        'Ženy|Džíny': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/06-600x243.jpg',
        'Ženy|Oblečení':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/07-600x243.jpg',
        'Ženy|Příslušenství':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/08-600x243.jpg',
        'Ženy|Kolekce':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/11-243x390.jpg'
      };*/

      const imgMap = {
        'Season sale -50 %|Muži':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Season-sale-50_hero-desktop-1.png?v=1766565897',
        'Season sale -50 %|Ženy':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Season-sale-50_hero-desktop-1.png?v=1766565897',
        'Nová kolekce|Muži':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Studio_Session_day_2-4776.jpg?v=1769197685',
        'Nová kolekce|Ženy':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Studio_Session_day_2-4776.jpg?v=1769197685',
        'Muži|Džíny': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/4_megamenu-men_jeans.jpg?v=1756090957',
        'Muži|Oblečení': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/4_megamenu-men_apparel.jpg?v=1756090958',
        'Muži|Doplňky': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/4_megamenu-men_doplnky-cepice.jpg?v=1756090957',
        'Muži|Boty': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Banner_2_MAN_Shoes_600x243_f200bd4c-0f85-4aad-8984-a61f446e47d2.jpg?v=1759405571',
        'Muži|Projekty': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/05-600x243.jpg',
        'Muži|Kolekce': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/05-600x243.jpg',
        'Ženy|Džíny': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/5_megamenu-women_jeans.jpg?v=1756090958',
        'Ženy|Oblečení':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/5_megamenu-women_apparel.jpg?v=1756090958',
        'Ženy|Doplňky':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/5_megamenu-women_doplnky.jpg?v=1756090957',
        'Ženy|Boty':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Banner_2_WOMAN_Shoes_600x243_50f8e197-16f7-4820-829a-daefb02fb816.jpg?v=1759405569',
        'Ženy|Kolekce':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/11-243x390.jpg'
      };

      function createMenuItem(title, url) {
        const a = document.createElement('a');
        a.href = url || '#';
        a.textContent = title;
        return a;
      }

      function createThirdLevel(thirdItems, parentTitle, topTitle) {
        if (!Array.isArray(thirdItems) || thirdItems.length === 0) return null;

        const wrapper = document.createElement('div');
        wrapper.className = 'replay-sub-submenu';

        const inner = document.createElement('div');
        inner.className = 'replay-sub-submenu-inner';

        const ul = document.createElement('ul');
        thirdItems.forEach(item => {
          const li = document.createElement('li');
          li.appendChild(createMenuItem(item.title, item.url));
          ul.appendChild(li);
        });

        const imgKey = `${topTitle}|${parentTitle}`;
        const imgSrc = imgMap[imgKey] || '';

        const imgDiv = document.createElement('div');
        imgDiv.className = 'submenu-image';
        if (imgSrc) {
          const img = document.createElement('img');
          img.src = imgSrc;
          img.alt = parentTitle;
          imgDiv.appendChild(img);
        }

        inner.appendChild(ul);
        inner.appendChild(imgDiv);
        wrapper.appendChild(inner);

        return wrapper;
      }

      menuItems.forEach(topItem => {
        const topLi = document.createElement('li');
        topLi.className = 'replay-menu-item';





        // seznam odkazů, které mají být jen na mobilu
        const hiddenOnDesktop = [
          '/pages/denim-fit-guide',
          '/pages/prodejny',
          '/pages/faq',
          '/policies/terms-of-service',
          '/policies/contact-information',
          '/pages/vernostni-karta',
          '/pages/replay-world'
        ];

        if (hiddenOnDesktop.includes(topItem.url)) {
          topLi.style.display = "none"; // hned schovat
          topLi.classList.add("mobile-only"); // pro přepis v CSS na mobilech
          topLi.classList.add('mobile-only');
        }





        topLi.appendChild(createMenuItem(topItem.title, topItem.url));

        if (Array.isArray(topItem.children) && topItem.children.length > 0) {
          const submenuWrapper = document.createElement('div');
          submenuWrapper.className = 'replay-submenu';

          const submenuUl = document.createElement('ul');
          submenuUl.className = 'replay-submenu-links';

          topItem.children.forEach(subItem => {
            const subLi = document.createElement('li');
            subLi.appendChild(createMenuItem(subItem.title, subItem.url));

            const thirdLevel = createThirdLevel(subItem.children, subItem.title, topItem.title);
            if (thirdLevel) subLi.appendChild(thirdLevel);

            submenuUl.appendChild(subLi);
          });

          submenuWrapper.appendChild(submenuUl);
          topLi.appendChild(submenuWrapper);
        }

        topUl.appendChild(topLi);
      });

      replayMenu.appendChild(topUl);

      const oldNav = document.querySelector('.header__nav');
      if (oldNav) oldNav.replaceWith(replayMenu);
      else document.body.appendChild(replayMenu);

      console.log('%c✅ Menu úspěšně vygenerováno z JSON!', 'color: green; font-weight: bold');

      // === Delay pro submenu (aby hned nemizelo) ===
      document.querySelectorAll('.replay-menu-item').forEach(item => {
        let hideTimeout;

        item.addEventListener('mouseenter', () => {
          clearTimeout(hideTimeout);
          item.classList.add('open');
        });

        item.addEventListener('mouseleave', () => {
          hideTimeout = setTimeout(() => {
            item.classList.remove('open');
          }, 300); // nastav si delay v ms (200–400 je ideál)
        });
      });

      // === Zvýraznění aktivní položky podle URL ===
      (function highlightActiveLinks() {
        const currentPath = window.location.pathname.replace(/\/$/, ""); 
        const links = document.querySelectorAll('.replay-megamenu-root a');

        links.forEach(link => {
          let linkPath = link.getAttribute('href');
          if (!linkPath) return;

          linkPath = linkPath.split("?")[0].replace(/\/$/, "");

          if (linkPath === currentPath) {
            // aktivovat samotný link
            link.classList.add("active");

            // projít všechny rodiče až k top-level
            let el = link.parentElement;
            while (el && !el.classList.contains('replay-megamenu-root')) {
              if (el.tagName === 'LI') {
                const a = el.querySelector('a');
                if (a) a.classList.add('active');
              }
              el = el.parentElement;
            }
          }
        });
      })();



    })
    .catch(err => {
      console.error('❌ Menu data nebyla nalezena nebo se načetla příliš pozdě:', err);
    });
});